import axios, { AxiosRequestConfig } from 'axios';
import type { GetDataIdsByQuery, GetDataQueryRequest, GetDataQueryResponse, QueryIdRequestBody, RowV5ResponseBody } from '../types/api/data';
import { createQueryFingerprint } from '../utils/createQueryFingerprint';
import { isApiException } from '../utils/isApiException';
import { AXIOS_BASE_CONFIG } from './axiosConfig';
import { deduplicateGet } from './deduplicateGet';
import { deduplicatePost } from './deduplicatePost';
import type { ApiContext } from './types';
export function createDataApi(ctx: ApiContext) {
  const BASE = `/v6/data-grid/${ctx.gridCode}`;
  return {
    createDataQuery: (params: QueryIdRequestBody) => deduplicatePost(`${BASE}/data-query::${createQueryFingerprint(params)}`, () => axios.post(`${BASE}/data-query`, params, AXIOS_BASE_CONFIG).then(response => response.data).catch(ctx.handleApiError)),
    getDataByQuery: (dataQueryId: string, offset: number, limit: number, hasSmartSearch: boolean, columns: string[]) => axios.post(`${BASE}/data/${dataQueryId}?offset=${offset}&limit=${limit}${hasSmartSearch ? '&smartSearch=true' : ''}`, {
      columns
    }, {
      ...AXIOS_BASE_CONFIG,
      // needed to cache POST requests
      // https://axios-cache-interceptor.js.org/config/request-specifics#cache-methods
      cache: {
        methods: ['post']
      }
    } as AxiosRequestConfig).then(response => response.data?.rows as RowV5ResponseBody[]).catch(ctx.handleApiError),
    getSummaryRow: (dataQueryId: string) => axios.get(`${BASE}/data/${dataQueryId}/summary`, AXIOS_BASE_CONFIG).then(response => response.data?.summaryRow?.cells as RowV5ResponseBody['cells']).catch(ctx.handleApiError),
    getCountByQuery: (dataQueryId: string) => axios.get(`${BASE}/data/${dataQueryId}/count`, AXIOS_BASE_CONFIG).then<number>(response => response.data?.totalRows).catch(ctx.handleApiError),
    getDataIdsByQuery: (dataQueryId: string, offset: number, limit: number, hasSmartSearch: boolean) => axios.get(`${BASE}/data/${dataQueryId}/id?offset=${offset}&limit=${limit}${hasSmartSearch ? '&smartSearch=true' : ''}`, AXIOS_BASE_CONFIG).then(response => response.data as GetDataIdsByQuery[]).catch(ctx.handleApiError),
    getDataQuery: (dataQueryId: GetDataQueryRequest) => deduplicateGet(`${BASE}/data-query/${dataQueryId}`, () => axios.get(`${BASE}/data-query/${dataQueryId}`, AXIOS_BASE_CONFIG).then(response => response?.data as GetDataQueryResponse).catch((error: Error & {
      response?: {
        data: unknown;
      };
    }) => {
      const errorData = error?.response?.data;
      const isErrorDG0010 = isApiException(errorData) && errorData?.errors?.some(error => error.code === 'PKG-DG-0010');
      if (isErrorDG0010) {
        throw error;
      }
      ctx.handleApiError(error);
    }))
  };
}